<template>
<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M384 141.248V928a32 32 0 1 0 64 0V218.56l242.688 242.688A32 32 0 1 0 736 416L438.592 118.656A32 32 0 0 0 384 141.248z"/></svg>
</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconSortUp',
} as DefineComponent
</script>